import { hotelSlice } from "main/features/hotel/hotelSlice";
import { hotelWaitingListSlice } from "main/features/hotel/hotelWaitingList/hotelWaitingListSlice";
import { calendarSlice } from "main/features/hotel/calendarSlice";
import { bookingSlice } from "main/features/booking/bookingSlice";
import { userSlice } from "main/features/user/userSlice";
import { preBookingSlice } from "main/slices/preBookingSlice";
import { breakpointSlice } from "main/slices/breakpointSlice";
import { masterDataSlice } from "main/slices/masterDataSlice";
import { notificationSlice } from "main/slices/notificationSlice";
import { topSlice } from "main/features/top/topSlice";
import { companySlice } from "main/features/company/companySlice";
import { checkInSlice } from "main/features/checkIn/checkInSlice";
import { accountParamSlice } from "main/slices/accountParamSlice";

export type ReduxState = {
  hotel: typeof hotelSlice.reducer;
  hotelWaitingList: typeof hotelWaitingListSlice.reducer;
  calendar: typeof calendarSlice.reducer;
  preBooking: typeof preBookingSlice.reducer;
  booking: typeof bookingSlice.reducer;
  user: typeof userSlice.reducer;
  breakpoint: typeof breakpointSlice.reducer;
  masterData: typeof masterDataSlice.reducer;
  notification: typeof notificationSlice.reducer;
  top: typeof topSlice.reducer;
  company: typeof companySlice.reducer;
  checkIn: typeof checkInSlice.reducer;
  accountParam: typeof accountParamSlice.reducer;
};

export const reducers: ReduxState = {
  hotel: hotelSlice.reducer,
  hotelWaitingList: hotelWaitingListSlice.reducer,
  calendar: calendarSlice.reducer,
  preBooking: preBookingSlice.reducer,
  booking: bookingSlice.reducer,
  user: userSlice.reducer,
  breakpoint: breakpointSlice.reducer,
  masterData: masterDataSlice.reducer,
  notification: notificationSlice.reducer,
  top: topSlice.reducer,
  company: companySlice.reducer,
  checkIn: checkInSlice.reducer,
  accountParam: accountParamSlice.reducer,
};
